export default function left(str, length) {
    if (str === null || str === undefined || length > str.length)
        return str;
    return str.slice(0, length);
}
